module.exports = __webpack_public_path__ + "img/add-math.37d7cbdc.svg";